import React, { useEffect, useRef, useState } from 'react';

import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { TabPanel, TabView } from 'primereact/tabview';

import { Tree } from 'primereact/tree';


import { PJAxios, sendLogin, usePJStore, setProfile, useProfile, useProfiles, useUserInfo } from '@jaf/jaf-react-core';
import Tag from '../Specifiche/Tag/Tag';
import './ModificaConfigurazione.css';

import LinkDetail from '../Specifiche/LinkDetail/LinkDetail';

import moment from 'moment/moment';
import { Toast } from 'primereact/toast';
import CatalogoOggetti from '../CatalogoOggetti/CatalogoOggetti';
import GestioneEventi from '../GestioneEventi/GestioneEventi';
import AggiungiNodo from '../Specifiche/AggiungiNodo/AggiungiNodo';
import InserisciDescrizione from '../Specifiche/InserisciDescrizione/InserisciDescrizione';
import ExternalChannels from '../Specifiche/ExternalChannels/ExternalChannels';
import FaqDetail from '../Specifiche/FaqDetail/FaqDetail';
import GestioneAlbero from '../Specifiche/GestioneAlbero/GestioneAlbero';
import NodeWindow from '../Specifiche/NodeWindow/NodeWindow';
import ProprietaForm from '../Specifiche/ProprietaForm/ProprietaForm';

import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';

import { Dialog } from 'primereact/dialog';
import ExternalSources from '../Specifiche/ExternalSources/ExternalSources';

import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { flushCache } from '../../api/ChatbotApi';

import { InputSwitch } from 'primereact/inputswitch';


function ModificaConfigurazione(props) {
    const profile = useProfile();
    const [tematica, setTematica] = useState(null);
    const [catalogoOggettiVisible, setCatalogoOggettiVisible] = useState(null);
    const { storage } = usePJStore((state) => state.storage)


    const [activeIndex, setActiveIndex] = useState(0);

    const [loading, setLoading] = useState([]);

    //alberi
    const [nodes, setNodes] = useState([]);

    const [faqs, setFaqs] = useState([]);
    const [myFaqs, setMyFaqs] = useState([]);

    const [dests, setDests] = useState([]);
    const [myDests, setMyDests] = useState([]);

    const [links, setLinks] = useState([]);

    const [eventi, setEventi] = useState([]);

    const toast = useRef(null);
    const [modifiedNodes, setModifiedNodes] = useState([]);
    const [toggleModifiedNodes, setToggleModifiedNodes] = useState([]);

    const [selectedNodeKey, setSelectedNodeKey] = useState(-1);


    const [expandedKeys, setExpandedKeys] = useState(JSON.parse(sessionStorage.getItem("expandedKeys")));

    const [selectedNode, setSelectedNode] = useState(props.selectedNode);

    const [albero, setAlbero] = useState(null);
    const [alberoCsv, setAlberoCsv] = useState(null);


    const [closedRoot, setClosedRoot] = useState(false)

    const getText = usePJStore((state) => state.i18n_getText)
    const bundles = usePJStore((state) => state.i18n_bundles)
    
    const getTextByLang = (lang, key) => {
      return bundles?.[lang]?.[key]
    }
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const messages = useRef(null);

    const isLogged = useUserInfo() != null;


    const [fullSizeTree, setFullSizeTree] = useState(false)

    const [showExpired, setShowExpired] = useState(true)
    const [showActive, setShowActive] = useState(true)
    const [showFuture, setShowFuture] = useState(true)
    const [showHidden, setShowHidden] = useState(true)

    const [showAll, setShowAll] = useState(true)

    const [showLegend, setShowLegend] = useState(false)
    const [flattenedNodes, setFlattenedNodes] = useState(null)

    const [showHiddenNodes, setShowHiddenNodes] = useState(false)

    useEffect(() => {
        //console.log("useEffect props.tematica", props.tematica)
        setTematica(props.tematica);
    }, [JSON.stringify(props.tematica)]);

    useEffect(() => {
        if (!isLogged) {
            sendLogin()
        }
    }, []);


    useEffect(() => {
        setClosedRoot(false)
        if (eventi != null) {
            eventi.forEach((evento) => {
                if (evento.data_inizio <= new Date().getTime() && new Date().getTime() <= evento.data_fine) {
                    setClosedRoot(true)
                }
            })
        }
    }, [eventi]);

    useEffect(() => {

        sessionStorage.setItem("expandedKeys", JSON.stringify(expandedKeys));

        if (expandedKeys === null) {
            setExpandedKeys([0]);
        }
    }, [expandedKeys]);

    const setNodesByNodeDetails = (nodeDetail) => {

        let nodes = [];

        let radice = {
            key: 0,
            //label: getText(tree.radice.albero_dn),
            label: nodeDetail.title,
            icon: "pi pi-sitemap",
            data: null,
            children: nodeDetail.children,
            root: true
        }

        if (nodeDetail.children != null && nodeDetail.children.length > 0) {
            nodeDetail.children.forEach((item) => {
                var label = (item.nodeType == 'M' || item.nodeType == 'D') ? item.title : item.nodeType == 'Q' ? item.question : "";
                let iconString = getIconV2(item);
                var ramo = {
                    key: item.idNode,
                    label: label,
                    icon: iconString,
                    data: item,
                    children: []

                }

                if (radice.key === item.elemento_padre_id) {
                    radice.children.push(ramo);
                } else {
                    if (radice.children.length > 0) {
                        appendRecursive(ramo, radice);
                    }
                }
            });
        }

        nodes.push(radice);
        setNodes(nodes)

        return nodes;
    }

    useEffect(() => {
        //console.log("useEffect - tematica", tematica)
        if (tematica != null && tematica.id_config != null) {
            setLoading(true);
            PJAxios().post('/gestioneConfigurazioni/listaEventi', { idConfig: tematica.id_config }).then((res) => {
                setEventi(res.data);
            });

            caricaDest();
            caricaLinks();
            caricaFaqs();

            PJAxios().post('/gestioneConfigurazioni/getFlattenedNodes', { idConfig: tematica.id_config }).then((res) => {
                setFlattenedNodes(res.data);
            })

            PJAxios().post('/gestioneConfigurazioni/modificaConfigurazioniV2', { idConfig: tematica.id_config }).then((res) => {
                const list = [];
                list.push(res.data.nodeDetail)
                setNodes(list)
                //setNodesByNodeDetails(res.data.nodeDetail)
            }).finally(() => {
                setLoading(false)
            });


            if (tematica.id_config == 60 || tematica.id_config == 64) {
                PJAxios().post('/chatbot/modificaConfigurazioni', { idConfig: tematica.id_config }).then((res) => {
                    setAlberoCsv(res.data.strutturaAlbero.albero);
                })
            }

        }

    }, [tematica]);

    useEffect(() => {
        console.log("alberoCsv changed", alberoCsv);
    }, [alberoCsv]);

    const showError = () => {
        messages.current.show({ severity: 'error', summary: getText("ERRORE"), detail: getText("ERRORE_GENERICO") });
    }

    const tornaAElencoTematiche = () => {
        sessionStorage.setItem("expandedKeys", null);
        sessionStorage.setItem("selectedNodeKey", 0);
        props.onTematicaSelected(null);
    }

    const onNodeOperation = (node) => {
        props.onNodeOperation(node);
        setSelectedNode(node);
    }

    const onEventoSaved = (nome) => {
        toast.current.show({ severity: 'success', life: 10000, summary: getText("ESITO"), detail: getText("EVENT_SAVED_SUCCESSFULLY_ON_TREE") + " " + nome });
    }

    const onEventiDeleted = () => {
        toast.current.show({ severity: 'success', life: 10000, summary: getText("ESITO"), detail: getText("OLD_EVENTS_DELETED") });

    }

    const onEditEventoTransactionCompleted = (success) => {
        toast.current.show({ severity: success ? 'success' : 'error', life: 10000, summary: getText("ESITO"), detail: success ? getText("EVENTS_TRANSACTION_SUCCESS") : getText("EVENTS_TRANSACTION_ERROR") });
    }

    /**
     * funzione che serve per caricare le sole faq visibili
     * @param {*} elemento_padre_id 
     */
    const caricaDest = () => {

        PJAxios().get('/gestioneConfigurazioni/loadAllDests').then((res) => {

            // 2. Mappa l'array per aggiungere le nuove proprietà
            const updatedItems = res.data.items.map(item => {
                // Crea una copia dell'oggetto per evitare modifiche dirette all'oggetto originale
                const newItem = { ...item };

                // Aggiungi le proprietà label_it e label_en (sostituisci con la logica appropriata)
                newItem.label_it = getTextByLang("it",item.label) // Esempio: usa il titolo esistente
                newItem.label_en = getTextByLang("en",item.label); // Esempio: usa il titolo esistente

                return newItem;
            });

            // 3. Imposta lo stato con l'array modificato
            setDests(updatedItems);

        });
    }

    const caricaLinks = () => {

        PJAxios().get('/gestioneConfigurazioni/loadAllLinks').then((res) => {
            setLinks(res.data)
        });
    }

    const caricaFaqs = () => {

        PJAxios().get('/gestioneConfigurazioni/loadAllFaqs').then((res) => {

            //console.log(res.data)
            // 2. Mappa l'array per aggiungere le nuove proprietà
            const updatedItems = res.data.map(item => {
                // Crea una copia dell'oggetto per evitare modifiche dirette all'oggetto originale
                const newItem = { ...item };

                // Aggiungi le proprietà label_it e label_en (sostituisci con la logica appropriata)
                newItem.icon = iconVisible
                newItem.label = getText(item.question)
                newItem.value = item.idItem
                newItem.domanda_it = getTextByLang("it",item.question)
                newItem.domanda_en = getTextByLang("en",item.question)
                newItem.risposta_it = getTextByLang("it",item.answer)
                newItem.risposta_en = getTextByLang("en",item.answer)

                return newItem;
            });

            setFaqs(updatedItems)
            setMyFaqs(updatedItems)
        });
    }



    const expandAll = () => {
        let _expandedKeys = {};

        for (let node of nodes) {
            expandNode(node, _expandedKeys);
        }

        setExpandedKeys(_expandedKeys);
    }

    const collapseAll = () => {
        setExpandedKeys([0]);
    };

    const expandNode = (node, _expandedKeys) => {
        if (node.children && node.children.length) {
            _expandedKeys[node.key] = true;

            for (let child of node.children) {
                expandNode(child, _expandedKeys);
            }
        }
    };

    const onModificationReceived = (item) => {

        var array = modifiedNodes;


        array.forEach((element) => {
            if (item.id_item === element.id_item && item.id_element === element.id_element) {
                array.pop(element)
            }
        })

        array.push(item);
        setModifiedNodes(array);
        setToggleModifiedNodes(!toggleModifiedNodes);
    }

    const onTagUpdate = (outcome) => {
        if (outcome) {
            props.onSuccess();
        } else {
            showError();
        }
    }

    const onNodeWindowUpdate = (outcome) => {
        onSave(tematica, outcome);
    }

    const onNodeLoaded = () => {

    }


    const iconScheduled = "pi pi-clock";
    const iconHidden = "pi pi-eye-slash";
    const iconVisible = "pi pi-eye";
    const iconExpired = "pi pi-exclamation-circle";


    const getIcon = (item) => {

        if (item.elemento.elemento_fltp === "M") {
            return "emptyMenuIcon";
        } else if (item.elemento.elemento_fltp === "S") {
            if (item.elemento.extra_fields.email != null) {
                return "pi pi-envelope";
            } else if (item.elemento.extra_fields.domanda_en != null) {

                if (isNodeHidden(item)) {
                    return iconHidden;
                } else if (item.elemento.extra_fields.open_dt != null && item.elemento.extra_fields.close_dt != null) {
                    if (moment(item.elemento.extra_fields.open_dt).isBefore(moment()) && moment(item.elemento.extra_fields.close_dt).isAfter(moment())) {
                        return iconVisible;
                    } else if (moment(item.elemento.extra_fields.open_dt).isAfter(moment()) && moment(item.elemento.extra_fields.close_dt).isAfter(moment())) {
                        return iconScheduled;
                    } else {
                        return iconExpired;
                    }
                } else {
                    return iconVisible;
                }


            } else if (item.elemento.extra_fields.tema_collegato != null) {
                return "pi pi-link";
            }
        }
    }

    const getIconV2 = (item) => {
        if (item.nodeType === "M") {
            return "emptyMenuIcon";
        } else if (item.nodeType === "D") {
            return "pi pi-envelope";
        } else if (item.nodeType === "Q") {
            if (item.hidden) {
                return iconHidden;
            } else if (item.open_dt != null && item.close_dt != null) {
                if (moment(item.open_dt).isBefore(moment()) && moment(item.close_dt).isAfter(moment())) {
                    return iconVisible;
                } else if (moment(item.open_dt).isAfter(moment()) && moment(item.close_dt).isAfter(moment())) {
                    return iconScheduled;
                } else {
                    return iconExpired;
                }
            } else {
                return iconVisible;
            }
        } else if (item.nodeType === "L") {
            return "pi pi-link";
        }


    }

    const onCatalogoSave = (tematica, showSuccess) => {

        PJAxios().post('/gestioneConfigurazioni/modificaConfigurazioniV2', { idConfig: props.tematica.id_config }).then((res) => {
            /*setOfflineBundles({it: {
            
                },en:{
                    
                }
            })*/

            onSave(null, true);
        })
    }

    const onSave = (t, showSuccess) => {
        //console.log("onSave", t, showSuccess);
        sessionStorage.setItem("expandedKeys", JSON.stringify(expandedKeys));
        sessionStorage.setItem("selectedNodeKey", selectedNodeKey);
        //console.log("props.onSave");
        props.onSave(t, showSuccess, expandedKeys);
    }

    const onError = (message) => {
        props.onError(message);
    }

    const salvaTutto2 = (operazioni) => {
        setLoading(true);
        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: operazioni, idConfig: props.tematica.id_config }).then((res) => {
            onSave(tematica, true);
            setModifiedNodes([]);
            flushCache(dbTest);
        }).finally(() => {
            setLoading(false)
        });
    }

    const configureTree = (tree, rootId) => {

        let nodes = [];

        let radice = {
            key: tree.radice.elemento_id,
            //label: getText(tree.radice.albero_dn),
            label: tree.radice.albero_dn,
            icon: "pi pi-sitemap",
            data: tree.radice,
            children: [],
            root: true
        }

        expandedKeys[tree.radice.elemento_id] = true;
        setExpandedKeys(expandedKeys);

        tree.listaCompletaRami.forEach((ramoItem) => {
            var icon = getIcon(ramoItem);

            //var label = getText(ramoItem.elemento.extra_fields.bundle != null ? ramoItem.elemento.extra_fields.bundle : ramoItem.elemento.extra_fields.titolo);
            var label = ramoItem.elemento.extra_fields.bundle != null ? ramoItem.elemento.extra_fields.bundle : ramoItem.elemento.extra_fields.titolo;
            if (label.length > 100) {
                label = label.slice(0, 100) + "...";
            }

            var ramo = {
                key: ramoItem.elemento_id,
                label: label,
                icon: icon,
                data: ramoItem,
                children: []

            }

            tree.listaCompletaFoglie.forEach((fogliaItem) => {

                icon = getIcon(fogliaItem);

                var labelSuffix = "";
                if (fogliaItem.elemento.extra_fields.open_dt != null && fogliaItem.elemento.extra_fields.close_dt != null) {
                    labelSuffix = " (" + moment(fogliaItem.elemento.extra_fields.open_dt).format("DD-MM-YYYY") + " a " + moment(fogliaItem.elemento.extra_fields.close_dt).format("DD-MM-YYYY") + ")";
                }


                //var labelF = getText(fogliaItem.elemento.extra_fields.titolo);
                var labelF = fogliaItem.elemento.extra_fields.titolo;
                if (labelF.length > 100) {
                    labelF = labelF.slice(0, 100) + "...";
                }


                var foglia = {
                    key: fogliaItem.elemento_id,
                    label: labelF + labelSuffix,
                    icon: icon,
                    data: fogliaItem,
                    children: []
                }

                if (fogliaItem.elemento_padre_id === ramoItem.elemento_id) {
                    ramo.children.push(foglia);
                }
            })

            if (ramoItem.elemento_padre_id === radice.data.elemento_id) {
                ramo.id_item_parent = tree.radice.extra_fields.id_item
                radice.children.push(ramo);
            } else {
                radice.children.forEach((radiceChilds) => {
                    if (ramoItem.elemento_padre_id === radiceChilds.key) {
                        try {
                            ramo.id_item_parent = radiceChilds.elemento.extra_fields.id_item
                            radiceChilds.children.push(ramo);
                        } catch (exception) {
                            //console.log(radiceChilds.elemento);
                        }

                    }
                })
            }
        })

        nodes.push(radice);
        return nodes;

    }
    const appendRecursive = (ramo, radice) => {
        radice.children.forEach((child) => {
            //console.log(ramo.data);

            if (child.idNode === ramo.key) {
                child.children.push(ramo);
            } else {
                if (child.children != null && child.children.length > 0) {
                    appendRecursive(ramo, child);
                }

            }
        })
    }

    const getLabel = (item) => {
        return item.elemento.extra_fields.bundle
    }


    const configureTree2 = (tree, rootId) => {

        let nodes = [];

        let radice = {
            key: tree.radice.elemento_id,
            //label: getText(tree.radice.albero_dn),
            label: tree.radice.albero_dn,
            icon: "pi pi-sitemap",
            data: tree.radice,
            children: [],
            root: true
        }

        aggiornaContatoriMenu(tree)

        tree.struttura.forEach((item) => {
            var label = getLabel(item);
            var ramo = {
                key: item.elemento_id,
                label: label,
                icon: getIcon(item),
                data: item,
                children: []

            }

            if (tree.radice.elemento_id === item.elemento_padre_id) {
                radice.children.push(ramo);
            } else {
                //console.log(radice);
                if (radice.children.length > 0) {
                    appendRecursive(ramo, radice);
                }
            }
        });
        nodes.push(radice);
        return nodes;
    }

    const recursiveFindSelectedNode = (node) => {
        if ((node.key === selectedNodeKey && selectedNodeKey === 0)) {
            setSelectedNode(null)
        } else if (node.idNode === selectedNodeKey) {
            setSelectedNode(node);
        } else {
            if (node.children != null) {
                node.children.forEach((child) => {
                    recursiveFindSelectedNode(child)
                })
            }

        }
    }

    useEffect(() => {
        nodes.forEach((node => {
            recursiveFindSelectedNode(node)
        }))

    }, [selectedNodeKey]);

    useEffect(() => {
        setShowAll(showActive && showExpired && showHidden && showFuture)
    }, [showActive, showExpired, showHidden, showFuture]);




    useEffect(() => {

        if (!selectedNode) {
            setSelectedNode(props.selectedNode);
        }

        if (selectedNode != null && props.id_gruppo_selezionato != null) {
            setActiveIndex(1)
        } else {
            setActiveIndex(0)
        }

    }, [selectedNode]);


    const handleDragDrop = (event) => {
        const tipiFoglie = ["Q", "D", "L"];

        try {
            if (tipiFoglie.includes(event.dropNode.nodeType)) {
                props.onError("Non è possibile trascinare oggetti dentro una foglia");
                return;
            }
        } catch (e) {

        }




        var bothMenu = false;
        try {
            bothMenu = event.dragNode.data.elemento.elemento_fltp === "M" && event.dropNode.data.elemento.elemento_fltp === "M";
        } catch (e) {

        }

        if (bothMenu) {
            props.onError("Non � possibile trascinare un menu dentro un menu");
        }

        if (!bothMenu) {
            flattenedNodes.forEach((item) => {
                if (event.dragNode.key === item.idNode) {
                    var m = [];

                    var itemToAdd = {
                        is_new: false,
                        id_tree: "jstree_tematica",
                        op_type: "move",
                        id_node: event.dragNode.key,
                        id_item_parent: event.dropNode.key,
                        position: event.dropIndex,
                        id_node_old_parent: item.idParent,
                        id_node_parent: event.dropNode.key,
                        old_position: item.itemOrder,
                        obj_type: "Q" === item.nodeType ? "itemFaq" : "menu",
                        id_item: item.idItem,
                    }

                    m.push(itemToAdd)
                    salvaTutto2(m);

                }
            })

            setNodes(event.value);
        }

    }

    const toggleCatalogoOggetti = () => {
        setCatalogoOggettiVisible(!catalogoOggettiVisible);
    }

    const isNodeHidden = (item) => {
        return (item.hidden === true)
    }




    const [attiviCount, setAttiviCount] = useState(0);
    const [allCount, setAllCount] = useState(0);
    const [hiddenCount, setHiddenCount] = useState(0);
    const [expiredCount, setExpiredCount] = useState(0);
    const [futureCount, setFutureCount] = useState(0);

    const aggiornaContatoriMenu = (tree) => {

        var all = 0;
        var hidden = 0;
        var attivi = 0;
        var future = 0;
        var expired = 0;

        tree.struttura.forEach((item) => {
            all = all + 1
            if (isNodeHidden(item)) {
                hidden = hidden + 1
            } else if (item.elemento.extra_fields.open_dt || item.elemento.extra_fields.close_dt) {

                if (moment(item.elemento.extra_fields.open_dt).isBefore(moment()) && moment(item.elemento.extra_fields.close_dt).isAfter(moment())) {
                    attivi = attivi + 1
                } else if (moment(item.elemento.extra_fields.open_dt).isAfter(moment()) && moment(item.elemento.extra_fields.close_dt).isAfter(moment())) {
                    future = future + 1
                } else {
                    expired = expired + 1
                }
            } else {
                attivi = attivi + 1
            }
        });


        setAllCount(all)
        setHiddenCount(hidden)
        setAttiviCount(attivi)
        setFutureCount(future)
        setExpiredCount(expired)


    }

    useEffect(() => {
        if (flattenedNodes != null) {
            aggiornaContatoriMenuV2(flattenedNodes)
        }
    }, [flattenedNodes]);

    const aggiornaContatoriMenuV2 = (nodes_) => {

        var all = 0;
        var hidden = 0;
        var attivi = 0;
        var future = 0;
        var expired = 0;
        nodes_.forEach((item) => {
            all = all + 1
            if (item.hidden) {
                hidden = hidden + 1
            } else if (item.openDt || item.closeDt) {

                if (moment(item.openDt).isBefore(moment()) && moment(item.closeDt).isAfter(moment())) {
                    attivi = attivi + 1
                } else if (moment(item.openDt).isAfter(moment()) && moment(item.closeDt).isAfter(moment())) {
                    future = future + 1
                } else {
                    expired = expired + 1
                }
            } else {
                attivi = attivi + 1
            }
        });


        setAllCount(all)
        setHiddenCount(hidden)
        setAttiviCount(attivi)
        setFutureCount(future)
        setExpiredCount(expired)


    }

    const exportToExcel = () => {
        const data = getCsvFromAlbero(alberoCsv);
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Configurazione larghezza colonne (come visto prima)
        worksheet['!cols'] = [
            { wch: 15 }, { wch: 40 }, { wch: 20 }, { wch: 35 }, { wch: 15 }, { wch: 10 }, { wch: 10 }
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // --- GENERAZIONE DATA E ORA ---
        const now = new Date();
        const datePart = now.toISOString().split('T')[0]; // Ottiene "2024-05-22"
        const timePart = now.getHours().toString().padStart(2, '0') +
            now.getMinutes().toString().padStart(2, '0'); // Ottiene "1430"

        const fileName = `data_${datePart}_${timePart}.xlsx`;
        // ------------------------------

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

        saveAs(blob, fileName); // Usa il nuovo nome file dinamico
    };

    const nodeTemplate = (node, options) => {
        let label = getText(node.label);
        let opacity = false;
        if (node.root) {
            label = <h5><b>{closedRoot && <del>{getText(node.label)}</del>}{!closedRoot && getText(node.label)}</b></h5>;

        } else if (node.url) {
            label = <a href={node.url}>{getText(node.label)}</a>;
        }
        else if (node.root == false && isNodeHidden(node)) {
            if (!showHidden) {
                opacity = true;
            } else {
                label = <del>{getText(label)}</del>;
            }

        } else if (node.openDt || node.closeDt) {

            if (moment(node.openDt).isBefore(moment()) && moment(node.closeDt).isAfter(moment())) {

                if (!showActive) {
                    opacity = true;
                } else {

                    label = <font >{getText(node.label)} {"(" + getText("FROM") + " " + new Date(node.openDt).toLocaleDateString('en-GB') + " " + getText("TO") + " "} {new Date(node.closeDt).toLocaleDateString('en-GB') + ")"}</font>
                }
            } else if (moment(node.openDt).isAfter(moment()) && moment(node.closeDt).isAfter(moment())) {
                if (!showFuture) {
                    opacity = true;
                } else {

                    label = <font >{getText(node.label)} {"(" + getText("FROM") + " " + new Date(node.openDt).toLocaleDateString('en-GB') + " " + getText("TO") + " "} {new Date(node.closeDt).toLocaleDateString('en-GB') + ")"}</font>
                }

            } else {
                if (!showExpired) {
                    opacity = true;
                } else {

                    label = <font >{getText(node.label)} {"(" + getText("FROM") + " " + new Date(node.openDt).toLocaleDateString('en-GB') + " " + getText("TO") + " "} {new Date(node.closeDt).toLocaleDateString('en-GB') + ")"}</font>
                }
            }
        } else {
            if (!showActive) {
                opacity = true;
            }
        }

        try {

            if (node.children != null && node.children.length > 0) {
                if (isNodeHidden(node)) {
                    label = <del><b>{getText(node.label)}{" [" + node.children.length + "]"}</b></del>;
                } else {

                    label = <b>{getText(node.label)}{" [" + node.children.length + "]"}</b>;
                }

            }
        } catch (e) { }


        return (

            <span className={options.className}>
                <div className="col-12">
                    <div className="formgroup-inline">
                        {/*<div className="field" onClick={handleLeftClick}>
                            <i className="pi pi-list" style={{width:"5px",height:"5px"}}></i>
                        </div>
        */}
                        {opacity &&
                            <div className="field" style={{ "opacity": "0.3" }}>
                                {label}
                            </div>
                        }
                        {!opacity &&
                            <div className="field">
                                {label}
                            </div>
                        }

                    </div>
                </div>
            </span >
        )
    }

    const onJumpBack = () => {
        props.onJumpBack();
    }

    const onFaqsLoaded = (res) => {
        setFaqs(configureTree(res.data.strutturaAlbero.albero_faq));
    }

    const onFaqCreated = () => {
        //console.log("onFaqCreated - bundle refresh")
        /*setOfflineBundles({it: {
    
        },en:{
            
        }
    })*/

    }

    const isNodeVisible = (selectedNode) => {
        return (selectedNode.elemento.extra_fields.nascondifaq === "N" || selectedNode.elemento.extra_fields.nascondiramo === "N" || selectedNode.elemento.extra_fields.nascondidest === "N" || selectedNode.elemento.extra_fields.nascondilink === "N");
    }

    /*const getCsvFromAlbero = (tree) => {
        let nodes = [];
        let hiddenNodes = [];

        tree.struttura.forEach((item) => {
            var label = getText(getLabel(item));
            //console.log("item", item)
            try {
                let hiddenNode = !isNodeVisible(item);

                if (hiddenNode) {
                    console.log("hidden node", item.elemento_id);
                    hiddenNodes.push(item.elemento_id);
                }
                console.log("node", item);
                if(hiddenNodes.includes(item.elemento_padre_id)){
                    console.log("parent hidden");
                }

                if (item.elemento.elemento_fltp == 'M' && (showHiddenNodes || (!hiddenNode && !hiddenNodes.includes(item.elemento_padre_id)))) {
                    if (item.elemento.extra_fields.groups != null) {

                        item.elemento.extra_fields.groups.forEach((gruppo) => {
                            var ramo = {
                                id_nodo: item.elemento_id,
                                descrizione_nodo: label,
                                nome_gruppo: gruppo.nome_gruppo,
                                descrizione_gruppo: gruppo.descrizione,
                                id_gruppo: gruppo.id_group,
                                padre: item.elemento_padre_id,
                                visible: isNodeVisible(item) && !hiddenNodes.includes(item.elemento_padre_id)

                            }
                            nodes.push(ramo);
                        });
                    } else {
                        var ramo = {
                            id_nodo: item.elemento_id,
                            descrizione_nodo: label,
                            nome_gruppo: "",
                            descrizione_gruppo: "",
                            id_gruppo: "",
                            padre: item.elemento_padre_id,
                            visible: isNodeVisible(item) && !hiddenNodes.includes(item.elemento_padre_id)


                        }
                        nodes.push(ramo);
                    }
                }

            } catch (e) {
                var ramo = {
                    id_nodo: item.elemento_id,
                    descrizione_nodo: label,
                    nome_gruppo: "",
                    descrizione_gruppo: "",
                    id_gruppo: "",
                    visible: isNodeVisible(item) && !hiddenNodes.includes(item.elemento_padre_id),
                }
                nodes.push(ramo);
            }


        });
        console.log("nodes for csv", nodes);
        return nodes;
    }*/

    const getCsvFromAlbero = (tree) => {
        let nodes = [];
        let hiddenNodes = [];

        // 1. Creiamo una mappa: Chiave = ID PADRE, Valore = EMAIL DEL FIGLIO
        // Questo ci permette di trovare l'email istantaneamente
        const emailMap = {};
        tree.struttura.forEach(item => {
            const email = item.elemento?.extra_fields?.email;
            const padreId = item.elemento_padre_id;
            if (email && padreId) {
                // Salviamo l'email associandola all'ID del suo padre
                // Se più figli hanno email, qui verrà salvata l'ultima trovata
                emailMap[padreId] = email;
            }
        });

        tree.struttura.forEach((item) => {
            const label = getText(getLabel(item));

            try {
                const isSelfHidden = !isNodeVisible(item);
                const isParentHidden = hiddenNodes.includes(item.elemento_padre_id);
                const shouldBeHiddenInCsv = isSelfHidden || isParentHidden;

                if (shouldBeHiddenInCsv) {
                    hiddenNodes.push(item.elemento_id);
                }

                const isVisibleFinal = !shouldBeHiddenInCsv;

                if (item.elemento.elemento_fltp === 'M' && (showHiddenNodes || isVisibleFinal)) {

                    // 2. Cerchiamo l'email nella mappa usando l'ID del nodo corrente
                    // Stiamo cercando: "C'è un figlio che ha me come padre e ha una mail?"
                    const emailDelFiglio = emailMap[item.elemento_id] || null;

                    const creaRamo = (gruppo = null) => ({
                        id_nodo: item.elemento_id,
                        descrizione_nodo: label,
                        nome_gruppo: gruppo ? gruppo.nome_gruppo : "",
                        descrizione_gruppo: gruppo ? gruppo.descrizione : "",
                        id_gruppo: gruppo ? gruppo.id_group : "",
                        padre: item.elemento_padre_id,
                        visible: isVisibleFinal,
                        email: emailDelFiglio // <--- Valore recuperato dalla mappa
                    });

                    if (item.elemento.extra_fields.groups != null) {
                        item.elemento.extra_fields.groups.forEach((gruppo) => {
                            nodes.push(creaRamo(gruppo));
                        });
                    } else {
                        nodes.push(creaRamo());
                    }
                }
            } catch (e) {
                console.error("Errore nel nodo", item.elemento_id, e);
                nodes.push({
                    id_nodo: item.elemento_id,
                    descrizione_nodo: label,
                    visible: false,
                    email: null
                });
            }
        });

        return nodes;
    };

    const renderTitle = () => {
        return <h5>{getText(selectedNode.title)}</h5>
    }

    return (
        <>

            {profile && profile.profile == 2 &&
                <>
                    <div className='Home'>
                        <div className="formgrid grid">
                            <div className="col-12">
                                <div className="formgroup-inline">
                                    <div className="field">
                                        <Button className="p-button-primary" onClick={() => tornaAElencoTematiche()}>
                                            <i className="pi pi-sitemap px-2"></i>
                                            <span className="px-3">{getText("TORNA_A_ELENCO_TEMATICHE")}</span>
                                        </Button>
                                    </div>
                                    <div className="field">
                                        {catalogoOggettiVisible && !loading && <Button label={getText("CATALOGO_OGGETTI_HIDE")} onClick={toggleCatalogoOggetti} icon="pi pi-list" />}
                                        {!catalogoOggettiVisible && !loading && <Button label={getText("CATALOGO_OGGETTI_SHOW")} onClick={toggleCatalogoOggetti} icon="pi pi-list" />}
                                    </div>


                                </div>
                            </div>
                        </div>

                        {!catalogoOggettiVisible &&
                            <div className="formgrid grid">
                                <div className={fullSizeTree ? "col-12" : "col-6"}  >
                                    <div className='formgroup-inline'>
                                        <div className={fullSizeTree ? "col-3" : "col-6"}>
                                            <span style={{ textAlign: 'left' }}>
                                                <h5 >{getText("STRUTTURA_DELLA_TEMATICA")}</h5>
                                            </span>
                                        </div>

                                    </div>


                                    <Card className='treeCard' >
                                        <div className='formgroup-inline'>
                                            <div className='formgroup-inline col-9'>
                                                <div>
                                                    <Button size="small" onClick={() => {

                                                        if (!showAll) {
                                                            setShowActive(true);
                                                            setShowExpired(true);
                                                            setShowFuture(true);
                                                            setShowHidden(true);
                                                        } else if (showAll) {
                                                            setShowActive(false);
                                                            setShowExpired(false);
                                                            setShowFuture(false);
                                                            setShowHidden(false);
                                                        }

                                                        //    setShowAll(!showAll)
                                                    }

                                                    } iconPos='right' icon={showAll ? "pi pi-minus" : "pi pi-plus"} label={getText("ALL") + " [" + allCount + "]"} className={!showAll && "p-button-outlined"} />&nbsp;&nbsp;&nbsp;
                                                </div>

                                                <div>

                                                    <Button size="small" onClick={() => setShowExpired(!showExpired)} iconPos='right' icon={showExpired ? "pi pi-minus" : "pi pi-plus"} label={getText("EXPIRED") + " [" + expiredCount + "]"} className={!showExpired && "p-button-outlined"} />&nbsp;&nbsp;

                                                </div>

                                                <div>
                                                    <Button size="small" onClick={() => setShowHidden(!showHidden)} iconPos='right' icon={showHidden ? "pi pi-minus" : "pi pi-plus"} label={getText("HIDDEN") + " [" + hiddenCount + "]"} className={!showHidden && "p-button-outlined"}></Button>&nbsp;&nbsp;
                                                </div>
                                                <div>
                                                    <Button size="small" onClick={() => setShowActive(!showActive)} iconPos='right' icon={showActive ? "pi pi-minus" : "pi pi-plus"} label={getText("ACTIVE") + " [" + attiviCount + "]"} className={!showActive && "p-button-outlined"} />&nbsp;&nbsp;
                                                </div>
                                                <div>
                                                    <Button size="small" onClick={() => setShowFuture(!showFuture)} iconPos='right' icon={showFuture ? "pi pi-minus" : "pi pi-plus"} label={getText("FUTURE") + " [" + futureCount + "]"} className={!showFuture && "p-button-outlined"} />
                                                </div>

                                            </div>

                                            <Dialog visible={showLegend} onHide={() => setShowLegend(false)}>
                                                <div className='formgroup-inline'>
                                                    <div className='col-3'>
                                                        <i className='pi pi-eye' />
                                                    </div>
                                                    <div className='col-9'>
                                                        {getText("ACTIVE")}
                                                    </div>
                                                </div>
                                                <div className='formgroup-inline'>
                                                    <div className='col-3'>
                                                        <i className='pi pi-eye-slash' />
                                                    </div>
                                                    <div className='col-9'>
                                                        {getText("HIDDEN")}
                                                    </div>
                                                </div>
                                                <div className='formgroup-inline'>
                                                    <div className='col-3'>
                                                        <i className='pi pi-clock' />
                                                    </div>
                                                    <div className='col-9'>
                                                        {getText("FUTURE")}
                                                    </div>
                                                </div>
                                                <div className='formgroup-inline'>
                                                    <div className='col-3'>
                                                        <i className='pi pi-exclamation-circle' />
                                                    </div>
                                                    <div className='col-9'>
                                                        {getText("EXPIRED")}
                                                    </div>
                                                </div>
                                            </Dialog>
                                            <div className='col-3' >
                                                <span className="p-buttonset" style={{ float: "right" }} >

                                                    <Button className="p-button-rounded p-button-text" size="small" icon={(options) => fullSizeTree ? <FullscreenExitIcon /> : <FullscreenIcon />} onClick={() => setFullSizeTree(!fullSizeTree)} />&nbsp;

                                                    <Button className="p-button-rounded p-button-text" size="small" icon={(options) => <UnfoldMoreIcon />} onClick={expandAll} />&nbsp;
                                                    <Button className="p-button-rounded p-button-text" size="small" icon={(options) => <UnfoldLessIcon />} onClick={collapseAll} />
                                                    <Button tooltip='Legenda' className="p-button-rounded p-button-text" size="small" icon="pi pi-question-circle" onClick={() => setShowLegend(true)} />
                                                </span>
                                            </div>



                                        </div>
                                        <br />
                                        <Tree
                                            className='treeData'
                                            dragdropScope="demo" onDragDrop={event => handleDragDrop(event)}
                                            nodeTemplate={nodeTemplate} selectionMode="single"
                                            selectionKeys={selectedNodeKey} onSelectionChange={e => setSelectedNodeKey(e.value)}

                                            value={nodes} loading={loading}
                                            expandedKeys={expandedKeys} onToggle={e => setExpandedKeys(e.value)}

                                        />


                                    </Card>
                                </div>

                                <div className={fullSizeTree ? "col-12" : "col-6"}  >
                                    {selectedNode &&
                                        <div className="formgrid grid">
                                            <div className="col-12"  >
                                                <span style={{ textAlign: 'left' }}>
                                                    {renderTitle()}

                                                </span>

                                                <Card style={{ height: '800px' }} >
                                                    {!loading &&
                                                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                                            <TabPanel header={getText("OPERAZIONI_SUL_NODO")}>
                                                                <GestioneAlbero idConfig={props.tematica.id_config} onNodeLoaded={onNodeLoaded} onSave={onSave} onModificationReceived={onModificationReceived} onNodeOperation={onNodeOperation} faqs={faqs} selectedNode={selectedNode} tematica={props.tematica} root={false} />
                                                            </TabPanel>


                                                            {selectedNode.nodeType === 'M' && (props.tematica.id_config === 64 || props.tematica.id_config === 60 || props.tematica.id_config === 38) &&
                                                                <TabPanel header={getText("PROPRIETA_FORM")}>
                                                                    <ProprietaForm onJumpBack={onJumpBack} selectedNode={selectedNode} id_gruppo_selezionato={props.id_gruppo_selezionato} selectedNodeKey={selectedNodeKey} onSave={onSave} tematica={props.tematica} root={false} />
                                                                </TabPanel>
                                                            }

                                                            {(!selectedNode.root) &&
                                                                <TabPanel header={getText("FINESTRA_DI_APERTURA")}>
                                                                    {selectedNode && <NodeWindow tematica={props.tematica} onSave={onSave} onNodeWindowUpdate={onNodeWindowUpdate} selectedNode={selectedNode} />}
                                                                </TabPanel>
                                                            }


                                                            {selectedNode.nodeType === 'M' &&
                                                                <TabPanel header={getText("AGGIUNGI")}>
                                                                    <AggiungiNodo onFaqCreated={onFaqCreated} onFaqsLoaded={onFaqsLoaded} expandedKeys={expandedKeys} faqs={faqs} myFaqs={myFaqs} dests={dests} links={links} selectedNode={selectedNode} onSave={onSave} tematica={props.tematica} root={false} />
                                                                </TabPanel>


                                                            }


                                                            {selectedNode.nodeType === 'Q' &&
                                                                <TabPanel header={getText("TAGS")}>

                                                                    <Tag onTagUpdate={onTagUpdate} selectedNode={selectedNode} />
                                                                </TabPanel>
                                                            }


                                                            <TabPanel header={getText("DETTAGLI")}>
                                                                <FaqDetail selectedNode={selectedNode} />
                                                            </TabPanel>

                                                            {selectedNode.nodeType === 'L' &&
                                                                <TabPanel header={getText("MODIFICA")}>
                                                                    <LinkDetail
                                                                        selectedNode={selectedNode}
                                                                        tematica={props.tematica}
                                                                        onSave={onSave}
                                                                    />
                                                                </TabPanel>
                                                            }


                                                            {selectedNode.nodeType === 'M' &&
                                                                <TabPanel header={getText("EXTERNAL_CHANNELS")}>

                                                                    <ExternalChannels selectedNode={selectedNode} />
                                                                </TabPanel>
                                                            }

                                                        </TabView>
                                                    }
                                                </Card>
                                            </div>
                                        </div>
                                    }
                                    {!selectedNode &&
                                        <>
                                            <span style={{ textAlign: 'left' }}>
                                                <h5>{props.tematica.name}</h5>
                                            </span>

                                            <Card style={{ height: '800px' }} >
                                                {!loading &&
                                                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                                                        <TabPanel header={getText("LISTA_EVENTI_DI_DISATTIVAZIONE")}>
                                                            <GestioneEventi albero={albero} tematica={props.tematica} onEventoSaved={onEventoSaved} onEventiDeleted={onEventiDeleted} onEditEventoTransactionCompleted={onEditEventoTransactionCompleted} />

                                                        </TabPanel>
                                                        <TabPanel header={getText("AGGIUNGI")}>
                                                            <AggiungiNodo onFaqsLoaded={onFaqsLoaded} onFaqCreated={onFaqCreated} albero={albero} onNodeOperation={onNodeOperation} onSave={onSave} faqs={faqs} selectedNode={selectedNode} tematica={props.tematica} root={true} rootChilds={nodes != null && nodes[0] && nodes[0].children && nodes[0].children.length} />
                                                        </TabPanel>
                                                        <TabPanel header={getText("MODIFICA")}>
                                                            <ExternalSources selectedNode={selectedNode} onSave={onSave} tematica={tematica} />
                                                        </TabPanel>


                                                        {(props.tematica.id_config == 64 || props.tematica.id_config === 60 && alberoCsv != null) &&
                                                            <TabPanel header={getText("ADMIN")}>
                                                                <Card className='pj-bg-white-special' >
                                                                    <div className='formgroup-inline'>
                                                                        <div className='col-7' style={{ textAlign: "left", paddingTop: "10px" }}>
                                                                            <b>{getText("SCARICA_PROFILAZIONI_EXCEL_DESC")}</b>

                                                                        </div>
                                                                        <div className='formgroup-inline col-4'>
                                                                            <div>
                                                                                {showHiddenNodes ? getText("ESCLUDI_NODI_NASCOSTI") : getText("INCLUDI_NODI_NASCOSTI")}
                                                                                <InputSwitch checked={showHiddenNodes} onChange={(e) => setShowHiddenNodes(e.value)} />
                                                                            </div>

                                                                        </div>
                                                                        <div className='col-1' style={{ textAlign: "right" }}>
                                                                            <Button icon="pi pi-download" className="p-button-success" onClick={exportToExcel} />
                                                                        </div>
                                                                    </div>
                                                                </Card>
                                                                <br />

                                                            </TabPanel>
                                                        }



                                                    </TabView>
                                                }
                                            </Card>
                                        </>
                                    }
                                </div>
                            </div>
                        }

                        {
                            catalogoOggettiVisible &&
                            <CatalogoOggetti onError={onError} onCatalogoSave={onCatalogoSave} myFaqs={myFaqs} myDests={dests} onSave={onSave} idConfig={props.tematica.id_config} />
                        }

                        <div className="p-fluid grid formgrid col-6">
                            <Toast ref={toast}></Toast>
                        </div>
                    </div >
                </>
            }
        </>
    )
}

export default ModificaConfigurazione
